import { useState, createContext } from "react";

export const ReportContext = createContext();

export const ReportProvider = ({ children }) => {
  const [showLoading, setShowLoading] = useState(false);
  const [showPhotoDirectionModal, setShowPhotoDirectionModal] = useState(false);
  const [data, setData] = useState();
  const [finalDocuments, setFinalDocuments] = useState();
  const [finalPhotos, setFinalPhotos] = useState([]);
  const [finalProblemPhotos, setFinalProblemPhotos] = useState([]);
  const [finalCommentPhotos, setFinalCommentPhotos] = useState([]);
  const [otherReportPhotos, setOtherReportPhotos] = useState([]);
  const [finalCheckList, setFinalCheckList] = useState([]);
  const [hidePhotoError, setHidePhotoError] = useState(false);

  return (
    <ReportContext.Provider
      value={{
        showLoading,
        setShowLoading,
        data,
        setData,
        finalDocuments,
        setFinalDocuments,
        finalPhotos,
        setFinalPhotos,
        finalProblemPhotos,
        setFinalProblemPhotos,
        finalCommentPhotos,
        setFinalCommentPhotos,
        otherReportPhotos,
        setOtherReportPhotos,
        finalCheckList,
        setFinalCheckList,
        showPhotoDirectionModal,
        setShowPhotoDirectionModal,
        hidePhotoError,
        setHidePhotoError
      }}
    >
      {children}
    </ReportContext.Provider>
  );
};
